export enum EJErrorCode {
  DAEMON_PROCESS_CANNOT_BE_KILLED = 'DAEMON_PROCESS_CANNOT_BE_KILLED',
  DAEMON_RPC_LOCK_ATTEMPT_ON_UNENCRYPTED_WALLET = 'DAEMON_RPC_LOCK_ATTEMPT_ON_UNENCRYPTED_WALLET',
  DAEMON_RPC_METHOD_NOT_FOUND = 'DAEMON_RPC_METHOD_NOT_FOUND',
  WALLET_DAEMON_STATE_NOT_STARTED = 'WALLET_DAEMON_STATE_NOT_STARTED',
  WALLET_LOCK_STATE_NOT_LOCKED = 'WALLET_LOCK_STATE_NOT_LOCKED',
  WALLET_LOCK_STATE_NOT_STAKING = 'WALLET_LOCK_STATE_NOT_STAKING',
  WALLET_LOCK_STATE_NOT_UNLOCKED = 'WALLET_LOCK_STATE_NOT_UNLOCKED',
  WALLET_STATE_NOT_EMPTY = 'WALLET_STATE_NOT_EMPTY',
  WALLET_STATE_NOT_READY = 'WALLET_STATE_NOT_READY',
  WALLET_TRANSACTION_AMOUNT_HIGHER_THAN_AVAILABLE = 'WALLET_TRANSACTION_AMOUNT_HIGHER_THAN_AVAILABLE',
  WALLET_PASSPHRASE_WRONG = 'WALLET_PASSPHRASE_WRONG',
}
